// Canonical book data with per-chapter verse counts and common aliases.
// Used by the bulk "Quick fill" features (range splitting + pasted lists) and by
// passage validation. Verse counts are accurate so that range splitting divides
// a passage evenly down to the verse.

export const BOOKS = [
  { name: "Genesis", aliases: ["genesis", "gen", "ge", "gn"], chapters: [31, 25, 24, 26, 32, 22, 24, 22, 29, 32, 32, 20, 18, 24, 21, 16, 27, 33, 38, 18, 34, 24, 20, 67, 34, 35, 46, 22, 35, 43, 55, 32, 20, 31, 29, 43, 36, 30, 23, 23, 57, 38, 34, 34, 28, 34, 31, 22, 33, 26] },
  { name: "Exodus", aliases: ["exodus", "exod", "exo", "ex"], chapters: [22, 25, 22, 31, 23, 30, 25, 32, 35, 29, 10, 51, 22, 31, 27, 36, 16, 27, 25, 26, 36, 31, 33, 18, 40, 37, 21, 43, 46, 38, 18, 35, 23, 35, 35, 38, 29, 31, 43, 38] },
  { name: "Leviticus", aliases: ["leviticus", "lev", "le", "lv"], chapters: [17, 16, 17, 35, 19, 30, 38, 36, 24, 20, 47, 8, 59, 57, 33, 34, 16, 30, 37, 27, 24, 33, 44, 23, 55, 46, 34] },
  { name: "Numbers", aliases: ["numbers", "num", "nu", "nm", "nb"], chapters: [54, 34, 51, 49, 31, 27, 89, 26, 23, 36, 35, 16, 33, 45, 41, 50, 13, 32, 22, 29, 35, 41, 30, 25, 18, 65, 23, 31, 40, 16, 54, 42, 56, 29, 34, 13] },
  { name: "Deuteronomy", aliases: ["deuteronomy", "deut", "deu", "dt"], chapters: [46, 37, 29, 49, 33, 25, 26, 20, 29, 22, 32, 32, 18, 29, 23, 22, 20, 22, 21, 20, 23, 30, 25, 22, 19, 19, 26, 68, 29, 20, 30, 52, 29, 12] },
  { name: "Joshua", aliases: ["joshua", "josh", "jos", "jsh"], chapters: [18, 24, 17, 24, 15, 27, 26, 35, 27, 43, 23, 24, 33, 15, 63, 10, 18, 28, 51, 9, 45, 34, 16, 33] },
  { name: "Judges", aliases: ["judges", "judg", "jdg", "jg"], chapters: [36, 23, 31, 24, 31, 40, 25, 35, 57, 18, 40, 15, 25, 20, 20, 31, 13, 31, 30, 48, 25] },
  { name: "Ruth", aliases: ["ruth", "rut", "ru"], chapters: [22, 23, 18, 22] },
  { name: "1 Samuel", aliases: ["1 samuel", "1samuel", "first samuel", "1 sam", "1sam", "i samuel", "i sam"], chapters: [28, 36, 21, 22, 12, 21, 17, 22, 27, 27, 15, 25, 23, 52, 35, 23, 58, 30, 24, 42, 15, 23, 29, 22, 44, 25, 12, 25, 11, 31, 13] },
  { name: "2 Samuel", aliases: ["2 samuel", "2samuel", "second samuel", "2 sam", "2sam", "ii samuel", "ii sam"], chapters: [27, 32, 39, 12, 25, 23, 29, 18, 13, 19, 27, 31, 39, 33, 37, 23, 29, 33, 43, 26, 22, 51, 39, 25] },
  { name: "1 Kings", aliases: ["1 kings", "1kings", "first kings", "1 kgs", "1kgs", "1 ki", "1ki", "i kings"], chapters: [53, 46, 28, 34, 18, 38, 51, 66, 28, 29, 43, 33, 34, 31, 34, 34, 24, 46, 21, 43, 29, 53] },
  { name: "2 Kings", aliases: ["2 kings", "2kings", "second kings", "2 kgs", "2kgs", "2 ki", "2ki", "ii kings"], chapters: [18, 25, 27, 44, 27, 33, 20, 29, 37, 36, 21, 21, 25, 29, 38, 20, 41, 37, 37, 21, 26, 20, 37, 20, 30] },
  { name: "1 Chronicles", aliases: ["1 chronicles", "1chronicles", "first chronicles", "1 chron", "1chron", "1 chr", "1chr", "i chronicles"], chapters: [54, 55, 24, 43, 26, 81, 40, 40, 44, 14, 47, 40, 14, 17, 29, 43, 27, 17, 19, 8, 30, 19, 32, 31, 31, 32, 34, 21, 30] },
  { name: "2 Chronicles", aliases: ["2 chronicles", "2chronicles", "second chronicles", "2 chron", "2chron", "2 chr", "2chr", "ii chronicles"], chapters: [17, 18, 17, 22, 14, 42, 22, 18, 31, 19, 23, 16, 22, 15, 19, 14, 19, 34, 11, 37, 20, 12, 21, 27, 28, 23, 9, 27, 36, 27, 21, 33, 25, 33, 27, 23] },
  { name: "Ezra", aliases: ["ezra", "ezr"], chapters: [11, 70, 13, 24, 17, 22, 28, 36, 15, 44] },
  { name: "Nehemiah", aliases: ["nehemiah", "neh", "ne"], chapters: [11, 20, 32, 23, 19, 19, 73, 18, 38, 39, 36, 47, 31] },
  { name: "Esther", aliases: ["esther", "est", "es"], chapters: [22, 23, 15, 17, 14, 14, 10, 17, 32, 3] },
  { name: "Job", aliases: ["job", "jb"], chapters: [22, 13, 26, 21, 27, 30, 21, 22, 35, 22, 20, 25, 28, 22, 35, 22, 16, 21, 29, 29, 34, 30, 17, 25, 6, 14, 23, 28, 25, 31, 40, 22, 33, 37, 16, 33, 24, 41, 30, 24, 34, 17] },
  { name: "Psalms", aliases: ["psalms", "psalm", "ps", "psa", "pss"], chapters: [6, 12, 8, 8, 12, 10, 17, 9, 20, 18, 7, 8, 6, 7, 5, 11, 15, 50, 14, 9, 13, 31, 6, 10, 22, 12, 14, 9, 11, 13, 25, 11, 22, 23, 28, 13, 40, 22, 13, 17, 13, 11, 5, 26, 17, 11, 9, 14, 20, 23, 19, 9, 6, 7, 23, 13, 11, 11, 17, 12, 8, 12, 11, 10, 13, 20, 7, 35, 36, 5, 24, 20, 28, 23, 10, 12, 20, 72, 13, 19, 16, 8, 18, 12, 13, 17, 7, 18, 52, 17, 16, 15, 5, 23, 11, 13, 12, 9, 9, 5, 8, 28, 22, 35, 45, 48, 43, 13, 31, 7, 10, 10, 9, 8, 18, 19, 2, 29, 176, 7, 8, 9, 4, 8, 5, 6, 5, 6, 8, 8, 3, 18, 3, 3, 21, 26, 9, 8, 24, 14, 10, 8, 12, 15, 21, 10, 20, 14, 9, 6] },
  { name: "Proverbs", aliases: ["proverbs", "prov", "pro", "prv", "pr"], chapters: [33, 22, 35, 27, 23, 35, 27, 36, 18, 32, 31, 28, 25, 35, 33, 33, 28, 24, 29, 30, 31, 29, 35, 34, 28, 28, 27, 28, 27, 33, 31] },
  { name: "Ecclesiastes", aliases: ["ecclesiastes", "eccl", "ecc", "qoheleth"], chapters: [18, 26, 22, 16, 20, 12, 29, 17, 18, 20, 10, 14] },
  { name: "Song of Songs", aliases: ["song of songs", "song of solomon", "song", "sos", "canticles"], chapters: [17, 17, 11, 16, 16, 13, 13, 14] },
  { name: "Isaiah", aliases: ["isaiah", "isa", "is"], chapters: [31, 22, 26, 6, 30, 13, 25, 22, 21, 34, 16, 6, 22, 32, 9, 14, 14, 7, 25, 6, 17, 25, 18, 23, 12, 21, 13, 29, 24, 33, 9, 20, 24, 17, 10, 22, 38, 22, 8, 31, 29, 25, 28, 28, 25, 13, 15, 22, 26, 11, 23, 15, 12, 17, 13, 12, 21, 14, 21, 22, 11, 12, 19, 12, 25, 24] },
  { name: "Jeremiah", aliases: ["jeremiah", "jer", "je", "jr"], chapters: [19, 37, 25, 31, 31, 30, 34, 22, 26, 25, 23, 17, 27, 22, 21, 21, 27, 23, 15, 18, 14, 30, 40, 10, 38, 24, 22, 17, 32, 24, 40, 44, 26, 22, 19, 32, 21, 28, 18, 16, 18, 22, 13, 30, 5, 28, 7, 47, 39, 46, 64, 34] },
  { name: "Lamentations", aliases: ["lamentations", "lam", "la"], chapters: [22, 22, 66, 22, 22] },
  { name: "Ezekiel", aliases: ["ezekiel", "ezek", "eze", "ezk"], chapters: [28, 10, 27, 17, 17, 14, 27, 18, 11, 22, 25, 28, 23, 23, 8, 63, 24, 32, 14, 49, 32, 31, 49, 27, 17, 21, 36, 26, 21, 26, 18, 32, 33, 31, 15, 38, 28, 23, 29, 49, 26, 20, 27, 31, 25, 24, 23, 35] },
  { name: "Daniel", aliases: ["daniel", "dan", "da", "dn"], chapters: [21, 49, 30, 37, 31, 28, 28, 27, 27, 21, 45, 13] },
  { name: "Hosea", aliases: ["hosea", "hos", "ho"], chapters: [11, 23, 5, 19, 15, 11, 16, 14, 17, 15, 12, 14, 16, 9] },
  { name: "Joel", aliases: ["joel", "joe", "jl"], chapters: [20, 32, 21] },
  { name: "Amos", aliases: ["amos", "am"], chapters: [15, 16, 15, 13, 27, 14, 17, 14, 15] },
  { name: "Obadiah", aliases: ["obadiah", "obad", "ob"], chapters: [21] },
  { name: "Jonah", aliases: ["jonah", "jon", "jnh"], chapters: [17, 10, 10, 11] },
  { name: "Micah", aliases: ["micah", "mic", "mi"], chapters: [16, 13, 12, 13, 15, 16, 20] },
  { name: "Nahum", aliases: ["nahum", "nah", "na"], chapters: [15, 13, 19] },
  { name: "Habakkuk", aliases: ["habakkuk", "hab", "hb"], chapters: [17, 20, 19] },
  { name: "Zephaniah", aliases: ["zephaniah", "zeph", "zep", "zp"], chapters: [18, 15, 20] },
  { name: "Haggai", aliases: ["haggai", "hag", "hg"], chapters: [15, 23] },
  { name: "Zechariah", aliases: ["zechariah", "zech", "zec", "zc"], chapters: [21, 13, 10, 14, 11, 15, 14, 23, 17, 12, 17, 14, 9, 21] },
  { name: "Malachi", aliases: ["malachi", "mal", "ml"], chapters: [14, 17, 18, 6] },
  { name: "Matthew", aliases: ["matthew", "matt", "mat", "mt"], chapters: [25, 23, 17, 25, 48, 34, 29, 34, 38, 42, 30, 50, 58, 36, 39, 28, 27, 35, 30, 34, 46, 46, 39, 51, 46, 75, 66, 20] },
  { name: "Mark", aliases: ["mark", "mrk", "mk", "mr"], chapters: [45, 28, 35, 41, 43, 56, 37, 38, 50, 52, 33, 44, 37, 72, 47, 20] },
  { name: "Luke", aliases: ["luke", "luk", "lk"], chapters: [80, 52, 38, 44, 39, 49, 50, 56, 62, 42, 54, 59, 35, 35, 32, 31, 37, 43, 48, 47, 38, 71, 56, 53] },
  { name: "John", aliases: ["john", "jhn", "jn"], chapters: [51, 25, 36, 54, 47, 71, 53, 59, 41, 42, 57, 50, 38, 31, 27, 33, 26, 40, 42, 31, 25] },
  { name: "Acts", aliases: ["acts", "act", "ac"], chapters: [26, 47, 26, 37, 42, 15, 60, 40, 43, 48, 30, 25, 52, 28, 41, 40, 34, 28, 41, 38, 40, 30, 35, 27, 27, 32, 44, 31] },
  { name: "Romans", aliases: ["romans", "rom", "ro", "rm"], chapters: [32, 29, 31, 25, 21, 23, 25, 39, 33, 21, 36, 21, 14, 23, 33, 27] },
  { name: "1 Corinthians", aliases: ["1 corinthians", "1corinthians", "first corinthians", "1 cor", "1cor", "i corinthians", "i cor"], chapters: [31, 16, 23, 21, 13, 20, 40, 13, 27, 33, 34, 31, 13, 40, 58, 24] },
  { name: "2 Corinthians", aliases: ["2 corinthians", "2corinthians", "second corinthians", "2 cor", "2cor", "ii corinthians", "ii cor"], chapters: [24, 17, 18, 18, 21, 18, 16, 24, 15, 18, 33, 21, 14] },
  { name: "Galatians", aliases: ["galatians", "gal", "ga"], chapters: [24, 21, 29, 31, 26, 18] },
  { name: "Ephesians", aliases: ["ephesians", "eph", "ep"], chapters: [23, 22, 21, 32, 33, 24] },
  { name: "Philippians", aliases: ["philippians", "phil", "php", "pp"], chapters: [30, 30, 21, 23] },
  { name: "Colossians", aliases: ["colossians", "col", "co"], chapters: [29, 23, 25, 18] },
  { name: "1 Thessalonians", aliases: ["1 thessalonians", "1thessalonians", "first thessalonians", "1 thess", "1thess", "1 thes", "1thes", "i thessalonians"], chapters: [10, 20, 13, 18, 28] },
  { name: "2 Thessalonians", aliases: ["2 thessalonians", "2thessalonians", "second thessalonians", "2 thess", "2thess", "2 thes", "2thes", "ii thessalonians"], chapters: [12, 17, 18] },
  { name: "1 Timothy", aliases: ["1 timothy", "1timothy", "first timothy", "1 tim", "1tim", "i timothy"], chapters: [20, 15, 16, 16, 25, 21] },
  { name: "2 Timothy", aliases: ["2 timothy", "2timothy", "second timothy", "2 tim", "2tim", "ii timothy"], chapters: [18, 26, 17, 22] },
  { name: "Titus", aliases: ["titus", "tit", "ti"], chapters: [16, 15, 15] },
  { name: "Philemon", aliases: ["philemon", "philem", "phm", "pm"], chapters: [25] },
  { name: "Hebrews", aliases: ["hebrews", "heb"], chapters: [14, 18, 19, 16, 14, 20, 28, 13, 28, 39, 40, 29, 25] },
  { name: "James", aliases: ["james", "jas", "jm"], chapters: [27, 26, 18, 17, 20] },
  { name: "1 Peter", aliases: ["1 peter", "1peter", "first peter", "1 pet", "1pet", "1 pe", "1pe", "i peter"], chapters: [25, 25, 22, 19, 14] },
  { name: "2 Peter", aliases: ["2 peter", "2peter", "second peter", "2 pet", "2pet", "2 pe", "2pe", "ii peter"], chapters: [21, 22, 18] },
  { name: "1 John", aliases: ["1 john", "1john", "first john", "1 jn", "1jn", "1 jo", "1jo", "i john"], chapters: [10, 29, 24, 21, 21] },
  { name: "2 John", aliases: ["2 john", "2john", "second john", "2 jn", "2jn", "2 jo", "2jo", "ii john"], chapters: [13] },
  { name: "3 John", aliases: ["3 john", "3john", "third john", "3 jn", "3jn", "3 jo", "3jo", "iii john"], chapters: [14] },
  { name: "Jude", aliases: ["jude", "jud"], chapters: [25] },
  { name: "Revelation", aliases: ["revelation", "rev", "re", "apocalypse"], chapters: [20, 29, 22, 11, 14, 17, 17, 13, 21, 11, 19, 17, 18, 20, 8, 21, 18, 24, 21, 15, 27, 21] }
];

export function normalizeText(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[–—]/g, "-")
    .replace(/\./g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function findBookFromStart(value) {
  const normalized = normalizeText(value);
  let bestMatch = null;
  BOOKS.forEach((book, bookIndex) => {
    book.aliases.forEach((alias) => {
      const cleanAlias = normalizeText(alias);
      if (normalized === cleanAlias || normalized.startsWith(cleanAlias + " ")) {
        if (!bestMatch || cleanAlias.length > bestMatch.alias.length) {
          bestMatch = { book, bookIndex, alias: cleanAlias };
        }
      }
    });
  });
  return bestMatch;
}

function parsePassageEndpoint(input, fallbackBook, boundary) {
  const originalInput = String(input || "").trim();
  const value = normalizeText(originalInput);
  const explicitBook = findBookFromStart(value);
  const book = explicitBook ? explicitBook.book : fallbackBook;
  const bookIndex = explicitBook ? explicitBook.bookIndex : BOOKS.indexOf(fallbackBook);
  const remainder = explicitBook ? value.slice(explicitBook.alias.length).trim() : value;

  if (!book) {
    throw new Error("Could not identify the book in: " + originalInput);
  }

  if (!remainder) {
    const chapter = boundary === "end" ? book.chapters.length : 1;
    const verse = boundary === "end" ? book.chapters[chapter - 1] : 1;
    return { book, bookIndex, chapter, verse, precision: "book" };
  }

  const parts = remainder.split(":");
  const chapter = Number(parts[0]);
  const hasVerse = parts.length === 2 && parts[1] !== "";
  const verse = hasVerse ? Number(parts[1]) : (boundary === "end" ? book.chapters[chapter - 1] : 1);

  if (parts.length > 2 || !Number.isInteger(chapter) || chapter < 1 || chapter > book.chapters.length) {
    throw new Error(book.name + " has " + book.chapters.length + " chapter(s). Check chapter " + parts[0] + ".");
  }

  if (!Number.isInteger(verse) || verse < 1 || verse > book.chapters[chapter - 1]) {
    throw new Error(book.name + " " + chapter + " has " + book.chapters[chapter - 1] + " verse(s). Check verse " + parts[1] + ".");
  }

  return { book, bookIndex, chapter, verse, precision: hasVerse ? "verse" : "chapter" };
}

function getEndForSingleEndpoint(startEndpoint) {
  if (startEndpoint.precision === "book") {
    const lastChapter = startEndpoint.book.chapters.length;
    return {
      book: startEndpoint.book,
      bookIndex: startEndpoint.bookIndex,
      chapter: lastChapter,
      verse: startEndpoint.book.chapters[lastChapter - 1],
      precision: "book"
    };
  }

  if (startEndpoint.precision === "chapter") {
    return {
      book: startEndpoint.book,
      bookIndex: startEndpoint.bookIndex,
      chapter: startEndpoint.chapter,
      verse: startEndpoint.book.chapters[startEndpoint.chapter - 1],
      precision: "chapter"
    };
  }

  return { ...startEndpoint };
}

export function comparePoints(a, b) {
  if (a.bookIndex !== b.bookIndex) return a.bookIndex - b.bookIndex;
  if (a.chapter !== b.chapter) return a.chapter - b.chapter;
  return a.verse - b.verse;
}

export function parsePassageRange(reference) {
  const normalized = normalizeText(reference);
  const dashIndex = normalized.indexOf("-");
  const startText = dashIndex === -1 ? normalized : normalized.slice(0, dashIndex).trim();
  const endText = dashIndex === -1 ? "" : normalized.slice(dashIndex + 1).trim();

  if (!startText) throw new Error("Add a starting passage or book.");

  const start = parsePassageEndpoint(startText, null, "start");
  let end;

  if (!endText) {
    end = getEndForSingleEndpoint(start);
  } else {
    const endHasExplicitBook = Boolean(findBookFromStart(endText));
    end = parsePassageEndpoint(endText, start.book, "end");
    if (!endHasExplicitBook) {
      end.book = start.book;
      end.bookIndex = start.bookIndex;
    }
  }

  if (comparePoints(start, end) > 0) {
    throw new Error("The passage range appears to end before it begins.");
  }

  return { start, end };
}

function nextVerse(point) {
  const maxVerse = point.book.chapters[point.chapter - 1];
  if (point.verse < maxVerse) return { ...point, verse: point.verse + 1 };
  if (point.chapter < point.book.chapters.length) return { ...point, chapter: point.chapter + 1, verse: 1 };
  const nextBook = BOOKS[point.bookIndex + 1];
  if (!nextBook) return null;
  return { book: nextBook, bookIndex: point.bookIndex + 1, chapter: 1, verse: 1 };
}

export function enumerateVerses(range) {
  const verses = [];
  let current = range.start;
  while (current && comparePoints(current, range.end) <= 0) {
    verses.push(current);
    current = nextVerse(current);
  }
  return verses;
}

function formatPoint(point) {
  return point.book.name + " " + point.chapter + ":" + point.verse;
}

export function formatRange(start, end) {
  if (start.bookIndex !== end.bookIndex) return formatPoint(start) + "-" + formatPoint(end);
  if (start.chapter === end.chapter) {
    if (start.verse === end.verse) return formatPoint(start);
    return start.book.name + " " + start.chapter + ":" + start.verse + "-" + end.verse;
  }
  return start.book.name + " " + start.chapter + ":" + start.verse + "-" + end.chapter + ":" + end.verse;
}

// Splits a passage range evenly into `slotCount` reading references.
export function splitPassageEvenly(reference, slotCount) {
  const range = parsePassageRange(reference);
  const verses = enumerateVerses(range);
  if (!verses.length) throw new Error("No verses were found for that range.");

  const chunkCount = Math.min(slotCount, verses.length);
  const readings = [];
  for (let index = 0; index < chunkCount; index += 1) {
    const startIndex = Math.floor((index * verses.length) / chunkCount);
    const endIndex = Math.floor(((index + 1) * verses.length) / chunkCount) - 1;
    readings.push(formatRange(verses[startIndex], verses[endIndex]));
  }
  return readings;
}

// Splits a pasted block of references (newline / comma / semicolon separated).
export function parseReadingList(rawList) {
  return String(rawList || "")
    .split(/[\n;,]+/)
    .map((item) => item.trim())
    .filter(Boolean);
}

function parseChapterVerse(token, book) {
  const parts = token.split(":");
  if (parts.length > 2) return { error: "Invalid reference: " + token };
  const chapter = Number(parts[0]);
  if (!Number.isInteger(chapter) || chapter < 1 || chapter > book.chapters.length) {
    return { error: book.name + " has " + book.chapters.length + " chapter(s)." };
  }
  if (parts.length === 1) return { chapter, verse: null };
  const verse = Number(parts[1]);
  if (!Number.isInteger(verse) || verse < 1 || verse > book.chapters[chapter - 1]) {
    return { error: book.name + " " + chapter + " has " + book.chapters[chapter - 1] + " verse(s)." };
  }
  return { chapter, verse };
}

// Validates a single passage reference using normal reading conventions
// (e.g. "John 3:16-18" is verses 16-18, "Genesis 1-3" is chapters 1-3).
// Falls back to cross-book range parsing for references like "1 Peter - 2 Peter".
// Returns { ok: true } or { ok: false, message }.
export function validateSingleReference(value) {
  const original = String(value || "").trim();
  if (!original) return { ok: true };

  const normalized = normalizeText(original);
  const found = findBookFromStart(normalized);

  if (!found) {
    try {
      parsePassageRange(original);
      return { ok: true };
    } catch (error) {
      return { ok: false, message: error.message };
    }
  }

  const book = found.book;
  const remainder = normalized.slice(found.alias.length).trim();
  // A bare book name (no chapter/verse) is not a valid plan passage.
  if (!remainder) {
    return { ok: false, message: 'Add a chapter, e.g. "' + book.name + ' 1".' };
  }

  const dash = remainder.indexOf("-");
  const left = dash === -1 ? remainder : remainder.slice(0, dash).trim();
  const right = dash === -1 ? "" : remainder.slice(dash + 1).trim();

  const leftParsed = parseChapterVerse(left, book);
  if (leftParsed.error) return { ok: false, message: leftParsed.error };
  if (!right) return { ok: true };

  if (right.includes(":") || findBookFromStart(right)) {
    // Cross-chapter or cross-book range: defer to the range parser.
    try {
      parsePassageRange(original);
      return { ok: true };
    } catch (error) {
      return { ok: false, message: error.message };
    }
  }

  const rightNum = Number(right);
  if (!Number.isInteger(rightNum) || rightNum < 1) {
    return { ok: false, message: "Invalid range end: " + right };
  }

  if (leftParsed.verse != null) {
    const maxVerse = book.chapters[leftParsed.chapter - 1];
    if (rightNum > maxVerse) {
      return { ok: false, message: book.name + " " + leftParsed.chapter + " has " + maxVerse + " verse(s)." };
    }
    if (rightNum < leftParsed.verse) {
      return { ok: false, message: "The range ends before it begins." };
    }
    return { ok: true };
  }

  if (rightNum > book.chapters.length) {
    return { ok: false, message: book.name + " has " + book.chapters.length + " chapter(s)." };
  }
  if (rightNum < leftParsed.chapter) {
    return { ok: false, message: "The range ends before it begins." };
  }
  return { ok: true };
}

// Returns the number of chapters spanned by a whole-chapter range
// (e.g. "Genesis 1-3" -> 3), or null when the reference is not a chapter range.
export function getChapterRangeSize(value) {
  const normalized = normalizeText(value);
  const found = findBookFromStart(normalized);
  if (!found) return null;
  const remainder = normalized.slice(found.alias.length).trim();
  const match = remainder.match(/^(\d+)-(\d+)$/);
  if (!match) return null;
  const start = Number(match[1]);
  const end = Number(match[2]);
  if (!Number.isInteger(start) || !Number.isInteger(end)) return null;
  return end - start + 1;
}
